(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    const detail = event.target.closest('.header__inline-menu details');
    if (!detail || detail.contains(event.relatedTarget)) return;
    let current = detail;
    while (current && current.closest('.header__inline-menu')) {
      current.open = true;
      current.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
      current = current.parentElement.closest('details');
    }
  });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const detail = event.target.closest('.header__inline-menu details');
    if (!detail) return;
    let current = detail;
    while (current && current.closest('.header__inline-menu')) {
      if (!current.contains(event.relatedTarget) && !current.contains(document.activeElement)) {
        current.open = false;
        current.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      }
      current = current.parentElement.closest('details');
    }
  });
  const positionFlyout = (detail) => {
    if (!detail.open || !detail.id.startsWith('Details-HeaderSubMenu-')) return;
    const submenu = detail.querySelector(':scope > ul');
    if (!submenu) return;
    const bounds = detail.getBoundingClientRect();
    detail.classList.toggle('sim-flyout-left', bounds.right + submenu.offsetWidth > window.innerWidth - 12);
  };
  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('.header__inline-menu details')) positionFlyout(event.target);
  }, true);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.header__inline-menu details[open]').forEach(positionFlyout);
  });
  } catch(e) { console.error(e); }
})();

})();
